import { View, Text as PDFText } from '@react-pdf/renderer'

import { RoomStay } from '../../../../../types/bookingDetails'
import { Currency } from '../../../../../types/currency'
import convertNumberToWord from '../../../FA/config/convertNumberToWord'
import { addCommaToPrice } from '../../config/functions'
import styles from './styles/index.styles'

interface RoomDetailsProps {
  data: RoomStay
  index: number
  currency: Currency
}

export const RoomDetails = ({ data, index, currency }: RoomDetailsProps) => {
  const haveExtraBedPrice = data.ratesPerDay.some((item) => item.extraBedRate)

  return (
    <View style={styles.mainDiv} wrap={false}>
      <View style={styles.content}>
        <View style={styles.contentColumn1}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>Guest Name:</PDFText>
            <PDFText style={{ ...styles.subjectValue, fontFamily: 'IRANSans' }}>
              {` ${data.profiles[0].firstName} ${data.profiles[0].lastName}`}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>National Code:</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.profiles[0].identificationNo}
            </PDFText>
          </View>
        </View>
        <View style={styles.contentColumn2}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>Checkin Date:</PDFText>
            <PDFText style={styles.subjectValue}>{data.checkIn}</PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>Checkout Date:</PDFText>
            <PDFText style={styles.subjectValue}>{data.checkOut}</PDFText>
          </View>
        </View>
        <View style={styles.contentColumn3}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>NO. Guests:</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.numberOfAdults}{' '}
              {data.addBed > 0 && <PDFText>( with </PDFText>}
              {data.addBed > 0 && <PDFText>{data.addBed} extrabeds ) </PDFText>}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>Price Per Night:</PDFText>
            {data.ratesPerDay.map((singleDay, i) => (
              <View
                key={i}
                style={{ flexDirection: 'row', alignItems: 'center' }}>
                <PDFText style={styles.subjectValue}>
                  {singleDay.date} -&nbsp;
                  {addCommaToPrice(singleDay.roomRate)}&nbsp;{currency}
                </PDFText>
              </View>
            ))}
          </View>
          {haveExtraBedPrice && (
            <View style={styles.subject}>
              <PDFText style={styles.subjectTitle}>Extra Bed Price:</PDFText>
              {data.ratesPerDay.map((singleDay, i) => (
                <PDFText key={i} style={styles.subjectValuePrice}>
                  {singleDay.date}
                  &nbsp;
                  {addCommaToPrice(singleDay.extraBedRate)}
                  &nbsp;
                  {currency}
                  &nbsp;
                </PDFText>
              ))}
            </View>
          )}
        </View>
        <View style={styles.contentColumn4}>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>Reservation No:</PDFText>
            <PDFText style={styles.subjectValue}>
              {data.displayReservationNumber}
            </PDFText>
          </View>
          <View style={styles.subject}>
            <PDFText style={styles.subjectTitle}>PMS Reservation No:</PDFText>
            <PDFText style={styles.subjectValue}>{data.pmsNumber}</PDFText>
          </View>
        </View>
      </View>
      <View style={styles.roomTitleContainer}>
        <View style={styles.roomTitle}>
          <PDFText style={styles.roomTitleLabel}>
            {convertNumberToWord(index + 1, 'en')} Room:{' '}
          </PDFText>
          {/* Room type names are often Persian, which Nunito has no glyphs for. */}
          <PDFText style={{ ...styles.roomTitleValue, fontFamily: 'IRANSans' }}>
            {data.roomTypeName}
          </PDFText>
        </View>
      </View>
    </View>
  )
}
